import Vue from 'vue'
import Vuex from 'vuex'
import actions from '@/store/actions'
import mutations from '@/store/mutations'
import getters from '@/store/getters'
import { TOKEN_NAME, COMPANY_LOCAL_TAG } from '@/constant/config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用户登录后返回的所有信息，包含token
    userInfo: JSON.parse(localStorage.getItem(TOKEN_NAME)),
    menuState: true,
    AMap: undefined,
    geolocation: undefined,
    companyInfo: JSON.parse(localStorage.getItem(COMPANY_LOCAL_TAG)) || {}
  },
  mutations,
  actions,
  getters
})
